const translations = {
  // ── Sub Dashboard ──
  'sub.dashboard.title': 'My Work',
  'sub.dashboard.subcontractor': 'Subcontractor',
  'sub.dashboard.projectsCount': '{count} project{s}',
  'sub.dashboard.instructionsCount': '{count} instruction{s}',
  'sub.dashboard.assignedProjects': 'Assigned Projects',
  'sub.dashboard.noProjectsAssigned': 'No projects assigned',
  'sub.dashboard.noProjectsAssignedDesc': 'You are not currently assigned to any projects. Japan Homes will assign you to a project here once it\'s set up.',
  'sub.dashboard.instructions': 'Instructions',
  'sub.dashboard.instructionsFromMgmt': 'From Management',
  'sub.dashboard.noActiveInstructions': 'No active instructions — you\'re all caught up!',
  'sub.dashboard.actionRequired': 'Action required',
  'sub.dashboard.instructionsDueSoon': '{count} instruction{s} due soon — tap to view',
  'sub.dashboard.subChecksPending': '{count} subcontractor {s} pending',
  'sub.dashboard.tapToOpenChecklist': 'Tap to open your checklist',
  'sub.dashboard.failedToLoad': 'Failed to load projects',
  'sub.dashboard.due': 'due',
  'sub.dashboard.stage': 'Stage',
  'sub.dashboard.backToDashboard': 'Back to dashboard',
  'sub.dashboard.viewAll': 'View all',

  // ── Sub Daily Log ──
  'sub.dailyLog.title': 'Daily Log',
  'sub.dailyLog.project': 'Project',
  'sub.dailyLog.allProjects': 'All Projects',
  'sub.dailyLog.photos': 'photos',
  'sub.dailyLog.today': 'Today',
  'sub.dailyLog.nonWorkingDay': 'Non-working day',
  'sub.dailyLog.noAssignedProjects': 'No assigned projects',
  'sub.dailyLog.noAssignedProjectsDesc': 'You do not have any active project assignments.',

  // ── Sub Instructions ──
  'sub.instructions.title': 'Instructions',
  'sub.instructions.management': 'Management',
  'sub.instructions.subcontractor': 'Subcontractor',
  'sub.instructions.allProjects': 'All Projects',
  'sub.instructions.allStatus': 'All Status',
  'sub.instructions.open': 'Open',
  'sub.instructions.inReview': 'In Review',
  'sub.instructions.resolved': 'Resolved',
  'sub.instructions.instructions': 'instructions',
  'sub.instructions.responseRequired': 'Response required',
  'sub.instructions.highPriority': 'High priority',
  'sub.instructions.due': 'Due',
  'sub.instructions.overdue': 'Overdue',
  'sub.instructions.reply': 'Reply',
  'sub.instructions.sendReply': 'Send Reply',
  'sub.instructions.sending': 'Sending...',
  'sub.instructions.progressUpdate': 'Progress Update',
  'sub.instructions.question': 'Question',
  'sub.instructions.issueReport': 'Issue Report',
  'sub.instructions.completed': 'Completed',
  'sub.instructions.acknowledge': 'Acknowledge',
  'sub.instructions.markCompleted': 'Mark Completed',
  'sub.instructions.cancel': 'Cancel',
  'sub.instructions.attach': 'Attach',
  'sub.instructions.replySent': 'Reply sent successfully',
  'sub.instructions.readMore': 'Read more',
  'sub.instructions.showLess': 'Show less',
  'sub.instructions.noInstructions': 'No instructions yet',
  'sub.instructions.noInstructionsProject': 'No instructions have been sent for {project} yet.',
  'sub.instructions.allCaughtUp': "You're all caught up",
  'sub.instructions.noInstructionsFilter': 'No {status} instructions',
  'sub.instructions.unknownProject': 'Unknown project',
  'sub.instructions.linkedItem': 'Linked item',

  // ── Sub Instructions NEW keys ──
  'sub.instructions.project': 'Project',
  'sub.instructions.statusOpen': 'Open',
  'sub.instructions.statusInReview': 'In Review',
  'sub.instructions.statusResolved': 'Resolved',
  'sub.instructions.statusSent': 'Sent',
  'sub.instructions.statusCompleted': 'Completed',
  'sub.instructions.statusClosed': 'Closed',
  'sub.instructions.priorityHigh': 'High Priority',
  'sub.instructions.priorityMedium': 'Medium Priority',
  'sub.instructions.priorityLow': 'Low Priority',
  'sub.instructions.acknowledged': 'Acknowledged',
  'sub.instructions.replyCount': '{count} {count, plural, one {reply} other {replies}}',
  'sub.instructions.attachCount': '{count} attached',
  'sub.instructions.instructionCount': '{count} instructions',
  'sub.instructions.selectProjectFirst': 'Select a project above to view or submit instructions.',
  'sub.instructions.noStatusInstructionsMsg': 'No {status} instructions',
  'sub.instructions.replySentSuccess': 'Reply sent successfully',
  'sub.instructions.sendError': 'Failed to send reply',
  'sub.instructions.authError': 'You must be logged in to reply.',
  'sub.instructions.subcontractorRole': 'Subcontractor',
  'sub.instructions.justNow': 'just now',
  'sub.instructions.minAgo': '{n} min ago',
  'sub.instructions.hrAgo': '{n} hr ago',
  'sub.instructions.hrsAgo': '{n} hrs ago',
  'sub.instructions.dayAgo': '{n} day ago',
  'sub.instructions.daysAgo': '{n} days ago',
  'sub.instructions.dueDateLabel': 'Due',
  'sub.instructions.errorAuth': 'You must be logged in to reply.',
  'sub.instructions.today': 'Today',
  'sub.instructions.yesterday': 'Yesterday',

  // ── Sub Notifications ──
  'sub.notifications.title': 'Notifications',
  'sub.notifications.all': 'All',
  'sub.notifications.unread': 'Unread',
  'sub.notifications.markAllRead': 'Mark all read',
  'sub.notifications.noNotifications': 'No notifications',
  'sub.notifications.noNotificationsDesc': 'Notifications will appear here',
  'sub.notifications.allCaughtUp': 'All caught up!',
  'sub.notifications.noUnread': 'No unread notifications',

  // ── Sub Project Detail ──
  'sub.project.overview': 'Overview',
  'sub.project.schedule': 'Schedule',
  'sub.project.checklist': 'Checklist',
  'sub.project.files': 'Files',
  'sub.project.constructionJourney': 'Construction Journey',
  'sub.project.noStages': 'No stages set up yet.',
  'sub.project.projectInfo': 'Project Info',
  'sub.project.site': 'Site',
  'sub.project.startDate': 'Start Date',
  'sub.project.estCompletion': 'Est. Completion',
  'sub.project.recentUpdates': 'Recent Updates',
  'sub.project.activeInstructions': 'Active Instructions',
  'sub.project.viewAll': 'View all',
  'sub.project.dailyLog': 'Daily Log',
  'sub.project.dailyLogDesc': 'Upload site photos by date',
  'sub.project.instructions': 'Instructions',
  'sub.project.instructionsDesc': 'View management requests',
  'sub.project.backToDashboard': 'Back to dashboard',
  'sub.project.backToProject': 'Back to {project}',
  'sub.project.myChecklist': 'My Checklist',
  'sub.project.pending': 'Pending',
  'sub.project.awaitingYourCheck': 'Awaiting your check',
  'sub.project.finalApproval': 'Final Approval',
  'sub.project.goToChecklist': 'Go to Checklist',
  'sub.project.pendingChecks': '{count} subcontractor {s} pending',
  'sub.project.pendingChecksDesc': 'These checklist items require your confirmation. Management has already checked them. Tap the Checklist tab below to complete your checks.',
  'sub.project.projectNotFound': 'Project not found',

  // ── Sub Stage Detail ──
  'sub.stage.stagePhotos': 'Stage Photos',
  'sub.stage.uploadPhoto': 'Upload Photo',
  'sub.stage.noPhotos': 'No photos yet — tap to upload',
  'sub.stage.stageUpdates': 'Stage Updates',
  'sub.stage.postUpdate': 'Post Update',
  'sub.stage.postUpdateTitle': 'Post Update',
  'sub.stage.describeUpdate': 'Describe what\'s happening on site...',
  'sub.stage.myChecklistItems': 'My Checklist Items',
  'sub.stage.pending': 'Pending',
  'sub.stage.check': 'Check',
  'sub.stage.completed': 'Completed',
  'sub.stage.subcontractorCheckProgress': 'Subcontractor Check Progress',
  'sub.stage.backToProject': 'Back to {project}',
  'sub.stage.noScheduledStage': 'No scheduled stage',
  'sub.stage.noScheduledStageNonWork': 'This is a non-working day.',
  'sub.stage.noScheduledStageFound': 'No scheduled stage found for this date.',
  'sub.stage.inProgress': 'In Progress',
  'sub.stage.stageProgress': 'Stage progress',
  'sub.stage.noPhotosYet': 'No photos yet',
  'sub.stage.uploadPhotosForDay': 'Upload photos for this day above',
  'sub.stage.savePhotos': 'Save Photos',
  'sub.stage.saving': 'Saving...',
  'sub.stage.photoUploaded': 'Photo uploaded successfully',
  'sub.stage.project': 'Project',
  'sub.stage.scheduledStage': 'Scheduled Stage',
  'sub.stage.uploadPhotos': 'Upload Photos',
  'sub.stage.dragDrop': 'Drag & drop photos here',
  'sub.stage.orTapBelow': 'or tap a button below',
  'sub.stage.gallery': 'Gallery',
  'sub.stage.camera': 'Camera',
  'sub.stage.pendingUploads': 'Pending uploads',
  'sub.stage.clearAll': 'Clear all',
  'sub.stage.photosForThisDay': 'Photos for this day',
  'sub.stage.noPhotosYetUpload': 'No photos yet',
  'sub.stage.readyToUpload': '{count} ready to upload',
  'sub.stage.noPendingUploads': 'No pending uploads',
  'sub.stage.selectProjectFirst': 'Please select a specific project above before uploading.',
  'sub.stage.uploadDisabled': 'Upload disabled',
  'sub.stage.uploadDisabledNonWork': 'Photo upload is not available on non-working days.',
  'sub.stage.nonWorkingDay': 'Non-working day',
  'sub.stage.uploadNotAvailable': 'Photo upload is disabled.',
  'sub.stage.updatesWillAppear': 'Updates will appear here once posted',
  'sub.stage.addPhoto': 'Add Photo',

  // ── Common Sub Labels ──
  'sub.common.progress': 'Progress',
  'sub.common.noDatesSet': 'No dates set',
  'sub.common.itemsCompleted': '{done}/{total} items completed',

  // ── Calendar month/weekday labels ──
  'sub.calendar.january': 'January',
  'sub.calendar.february': 'February',
  'sub.calendar.march': 'March',
  'sub.calendar.april': 'April',
  'sub.calendar.may': 'May',
  'sub.calendar.june': 'June',
  'sub.calendar.july': 'July',
  'sub.calendar.august': 'August',
  'sub.calendar.september': 'September',
  'sub.calendar.october': 'October',
  'sub.calendar.november': 'November',
  'sub.calendar.december': 'December',
  'sub.calendar.sun': 'Sun',
  'sub.calendar.mon': 'Mon',
  'sub.calendar.tue': 'Tue',
  'sub.calendar.wed': 'Wed',
  'sub.calendar.thu': 'Thu',
  'sub.calendar.fri': 'Fri',
  'sub.calendar.sat': 'Sat',

  // ── Daily Log UI strings ──
  'sub.dailyLog.project': 'Project',
  'sub.dailyLog.selectProject': 'Select a project above to view or submit Daily Logs.',
  'sub.dailyLog.loadingStatus': 'Loading project status…',
  'sub.dailyLog.projectProgress': 'Project Progress',
  'sub.dailyLog.scheduleFinal': 'Schedule Final',
  'sub.dailyLog.checklistFinal': 'Checklist Final',
  'sub.dailyLog.complete': '% complete',
  'sub.dailyLog.todayBtn': 'Today',
  'sub.dailyLog.completedBadge': 'Completed',
  'sub.dailyLog.pendingReview': 'Pending review',
  'sub.dailyLog.approved': 'Approved',
  'sub.dailyLog.rejected': 'Rejected',
  'sub.dailyLog.internalOnly': 'Internal only',
  'sub.dailyLog.mixed': 'Mixed',
  'sub.dailyLog.submittedBadge': 'Submitted',
  'sub.dailyLog.logCountBadge': '{count} logs',
  'sub.dailyLog.photoCountBadge': '{count} photos',
  'sub.dailyLog.onePhotoBadge': '1 photo',
  'sub.dailyLog.loadErrorTitle': 'Could not load daily logs',
  'sub.dailyLog.retryLoad': 'Retry',
  'sub.dailyLog.noAssignedProjectsLong': 'No assigned projects',
  'sub.dailyLog.noAssignedProjectsLongDesc': 'You do not have any active project assignments.',
  'sub.dailyLog.selectProjectTitle': 'Select a project',
  'sub.dailyLog.selectProjectDesc': 'Select a project above to view or submit Daily Logs.',
  'sub.dailyLog.noPhotos': 'photos',

  // ── Dashboard status labels ──
  'sub.dashboard.statusOpen': 'Open',
  'sub.dashboard.statusInReview': 'In Review',
  'sub.dashboard.statusResolved': 'Resolved',
  'sub.dashboard.statusCompleted': 'Completed',
  'sub.dashboard.overdue': 'Overdue',
  'sub.dashboard.dueToday': 'Due today',
  'sub.dashboard.dueTomorrow': 'Due tomorrow',
  'sub.dashboard.dueSoon': 'Due {date}',
  'sub.dashboard.instructionsTitle': 'Instructions',
  'sub.dashboard.unknownProject': 'Unknown project',
  'sub.dashboard.failedToLoadProjects': 'Failed to load projects',

  // ── Project page strings ──
  'sub.project.backToDashboard2': 'Back to dashboard',
  'sub.project.datesTBC': 'Dates TBC',
  'sub.project.tbc': 'TBC',
  'sub.project.datesRange': '{start} — {end}',
  'sub.project.completedLabel': 'Completed',
  'sub.project.inProgressLabel': 'In Progress',
  'sub.project.upcomingLabel': 'Upcoming',
  'sub.project.delayedLabel': 'Delayed',
  'sub.project.onHoldLabel': 'On Hold',
  'sub.project.generalUpdate': 'General',
  'sub.project.pendingChecksDesc': 'These checklist items require your confirmation. Management has already checked them. Tap the Checklist tab below to complete your checks.',
  'sub.project.dailyLogDesc2': 'Upload site photos by date',
  'sub.project.instructionsDesc2': 'View management requests',

  // ── Stage page strings ──
  'sub.stage.mgmtDone': 'Mgmt: Done',
  'sub.stage.mgmtPending': 'Mgmt: Pending',
  'sub.stage.subPending': 'Sub: Pending',
  'sub.stage.subDone': 'Sub: Done',
  'sub.stage.finalComplete': 'Final: Complete',
  'sub.stage.waitingForSubcontractor': 'Waiting for Subcontractor',
  'sub.stage.checkLabel': 'Check',
  'sub.stage.progressTag': 'Progress',
  'sub.stage.issueTag': 'Issue',
  'sub.stage.completeTag': 'Complete',
  'sub.stage.backToProjectShort': 'Back to {project}',
  'sub.stage.stageNotFound': 'Stage not found',
  'sub.stage.photoUploadedSuccess': 'Photo uploaded successfully',
  'sub.stage.doneCount': '{completed}/{total} done',
};

export default translations;